import { useEffect, useState } from "react";
import { LuMenu, LuX, LuGlobe } from "react-icons/lu";
import { useLang } from "../i18n";
import { navLinks } from "../data/content";
import { useDemoModal } from "../context/DemoModalContext";
import "./Header.css";

/**
 * Mirror of the Platform's app chrome: white header, thin bottom border,
 * wordmark logo (LoginPageShell). We keep the header light always so the
 * purple brand wordmark reads correctly on top of the light hero.
 */
export default function Header() {
  const { lang, setLang, t } = useLang();
  const { open: openDemoModal } = useDemoModal();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className={`site-header${scrolled ? " scrolled" : ""}`}>
      <div className="container site-header-inner">
        <a href="#hero" className="logo" onClick={closeMobile} aria-label="Nrativ">
          <img src="/img/nrativ.png" alt="Nrativ — Data Analytics" />
        </a>

        <nav
          className={`main-nav${mobileOpen ? " open" : ""}`}
          aria-label="Primary"
        >
          <ul>
            {navLinks.map((l) => (
              <li key={l.id}>
                <a href={`#${l.id}`} onClick={closeMobile}>
                  {t(l.label)}
                </a>
              </li>
            ))}
          </ul>

          <div className="lang-switch" role="group" aria-label="Language">
            <LuGlobe size={14} aria-hidden />
            <button
              type="button"
              className={lang === "sv" ? "active" : ""}
              onClick={() => setLang("sv")}
            >
              SV
            </button>
            <span aria-hidden>/</span>
            <button
              type="button"
              className={lang === "en" ? "active" : ""}
              onClick={() => setLang("en")}
            >
              EN
            </button>
          </div>

          <button
            type="button"
            className="btn btn-primary header-cta"
            onClick={() => {
              closeMobile();
              openDemoModal();
            }}
          >
            {t({ sv: "Boka demo", en: "Book demo" })}
          </button>
        </nav>

        <button
          type="button"
          className="mobile-toggle"
          onClick={() => setMobileOpen((o) => !o)}
          aria-label={mobileOpen ? "Stäng meny" : "Öppna meny"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <LuX size={24} /> : <LuMenu size={24} />}
        </button>
      </div>
    </header>
  );
}
